import { render } from "./DeltaDisplay.vue?vue&type=template&id=781e8eb5&scoped=true"
import script from "./DeltaDisplay.vue?vue&type=script&lang=js"
export * from "./DeltaDisplay.vue?vue&type=script&lang=js"

import "./DeltaDisplay.vue?vue&type=style&index=0&id=781e8eb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781e8eb5"]])

export default __exports__